// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"cfe67d1e","72":"a3e604dd","87":"dc073198","121":"8681a0a4","163":"fbf4b053","251":"1a4ffae7","444":"eca3bf97","460":"e92cc32f","606":"c54a2b4e","693":"9243f72e","767":"43d5a9ad"}[chunkId] + ".chunk.js";
};